import axios from '@/plugins/axios'

export function getWorkOrders(params = {}) {
  return axios.get('work_order', {
    params,
  })
}

export function getworkOrderTypes() {
  return axios.get('work_order/workOrderType')
}

export function addworkOrder(data) {
  return axios.post('work_order/addworkOrder', data)
}

export function mulOverWorkOrder(data) {
  return axios.post('work_order/mulOverWorkOrder', data)
}

export function mulAssignWorkOrder(data) {
  return axios.post('work_order/mulAssignWorkOrder', data)
}

export function getWarningByWorkOrderId(params = {}) {
  return axios.get('work_order/getWarningByWorkOrderId', {
    params,
  })
}

export function getWorkOrderDetail(params = {}) {
  return axios.get('work_order/workOrderDetail', {
    params,
  })
}

export function getBikeTimeTrajectory({bike_no, time_between}) {
  return axios.get('work_order/getBikeTimeTrajectory', {
    params: {
      bike_no,
      'time_between[0]': time_between && time_between[0],
      'time_between[1]': time_between && time_between[1]
    }
  })
}
